import { IconLock, IconSettings, IconUsers } from "@tabler/icons-react";

export const UserNavigation = [
	{
		title: "Settings",
		url: "/user/settings",
		icon: IconSettings,
	},
	{
		title: "Security",
		url: "/user/security",
		icon: IconLock,
	},
	{
		title: "Teams",
		url: "/user/teams",
		icon: IconUsers,
	},
];
